"use client";

import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/contexts/theme-context";
import { cn } from "@/lib/utils";

interface ThemeSwitcherPopoverProps {
  collapsed?: boolean;
}

export function ThemeSwitcherPopover({ collapsed = false }: ThemeSwitcherPopoverProps) {
  const { theme, setTheme } = useTheme();

  // Get the current theme icon
  const getCurrentIcon = () => {
    if (theme === 'light') {
      return <Sun className="h-4 w-4" />;
    } else {
      return <Moon className="h-4 w-4" />;
    }
  };

  // Toggle between light and dark
  const toggleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else {
      setTheme('light');
    }
  };

  return (
    <div className="relative">
      <button
        onClick={toggleTheme}
        className={cn(
          "text-muted-foreground hover:text-foreground transition-colors p-1.5",
          collapsed && "w-full flex justify-center"
        )}
        title={`Theme: ${theme === 'light' ? 'Light' : 'Dark'}`}
      >
        {getCurrentIcon()}
      </button>
    </div>
  );
}